'use strict';

var processInclude = require('base/util');

window.addEventListener('load', function () {
    processInclude(require('./checkout/countriesandregions'));
});
